function Switch() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.69865 6.69489C7.81713 5.57642 9.19824 4.88621 10.6429 4.62156L10.2825 2.6543C8.45142 2.98975 6.69901 3.86611 5.28444 5.28068C1.57446 8.99066 1.57446 15.0057 5.28444 18.7157L3.57733 20.4228H8.40576V15.5944L6.69865 17.3015C3.76972 14.3726 3.76972 9.62383 6.69865 6.69489ZM20.4248 3.57535H15.5964V8.40377L17.3035 6.69667C20.2324 9.6256 20.2324 14.3743 17.3035 17.3033C16.185 18.4217 14.8039 19.1119 13.3592 19.3766L13.7196 21.3439C15.5507 21.0084 17.3031 20.132 18.7177 18.7175C22.4277 15.0075 22.4277 8.99243 18.7177 5.28245L20.4248 3.57535Z" fill="#6FABB6" />
    </svg>
  );
}

export default Switch;
